module.exports = __webpack_public_path__ + "static/img/bomComparisonManege.ba38d1b6.png";